import "./hb-mine.module.css";
import { html } from "lit-html";
import { isPopup } from "../../global";

const hb = new URL("../../../public/hb.svg", import.meta.url).href;

export default (user) => html`
    <div
        id="hb-mine"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3
                        id="hb-mine-title"
                        class="text-xl inline-flex font-semibold text-gray-900 dark:text-white">
                        HeartBank® Mining ℹ️
                    </h3>
                    <aside>
                        <button
                            type="button"
                            id="hb-mine-stamp-unlink"
                            class="hidden mr-2">
                            <svg
                                class="w-4 h-4 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 448 512">
                                <path
                                    d="M64 160l64 0 0-64-64 0 0 64zM0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM64 416l64 0 0-64-64 0 0 64zM0 336c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM320 96l0 64 64 0 0-64-64 0zM304 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zM288 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm96 32c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm32-96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-32 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z" />
                            </svg>
                        </button>
                        <button
                            type="button"
                            id="hb-mine-stamp-link"
                            class="hidden mr-2">
                            <svg
                                class="w-4 h-4 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 576 512">
                                <path
                                    d="M419.5 96c-16.6 0-32.7 4.5-46.8 12.7-15.8-16-34.2-29.4-54.5-39.5 28.2-24 64.1-37.2 101.3-37.2 86.4 0 156.5 70 156.5 156.5 0 41.5-16.5 81.3-45.8 110.6l-71.1 71.1c-29.3 29.3-69.1 45.8-110.6 45.8-86.4 0-156.5-70-156.5-156.5 0-1.5 0-3 .1-4.5 .5-17.7 15.2-31.6 32.9-31.1s31.6 15.2 31.1 32.9c0 .9 0 1.8 0 2.6 0 51.1 41.4 92.5 92.5 92.5 24.5 0 48-9.7 65.4-27.1l71.1-71.1c17.3-17.3 27.1-40.9 27.1-65.4 0-51.1-41.4-92.5-92.5-92.5zM275.2 173.3c-1.9-.8-3.8-1.9-5.5-3.1-12.6-6.5-27-10.2-42.1-10.2-24.5 0-48 9.7-65.4 27.1L91.1 258.2c-17.3 17.3-27.1 40.9-27.1 65.4 0 51.1 41.4 92.5 92.5 92.5 16.5 0 32.6-4.4 46.7-12.6 15.8 16 34.2 29.4 54.6 39.5-28.2 23.9-64 37.2-101.3 37.2-86.4 0-156.5-70-156.5-156.5 0-41.5 16.5-81.3 45.8-110.6l71.1-71.1c29.3-29.3 69.1-45.8 110.6-45.8 86.6 0 156.5 70.6 156.5 156.9 0 1.3 0 2.6 0 3.9-.4 17.7-15.1 31.6-32.8 31.2s-31.6-15.1-31.2-32.8c0-.8 0-1.5 0-2.3 0-33.7-18-63.3-44.8-79.6z" />
                            </svg>
                        </button>
                        <button
                            id="hb-mine-close"
                            type="button"
                            class="${isPopup
                                ? "hidden"
                                : "inline-flex"} end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            data-modal-hide="hb-mine">
                            <svg
                                class="w-4 h-4"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 384 512">
                                <path
                                    d="M55.1 73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L147.2 256 9.9 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192.5 301.3 329.9 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.8 256 375.1 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192.5 210.7 55.1 73.4z" />
                            </svg>
                            <span class="sr-only">Close</span>
                        </button>
                    </aside>
                </div>
                <!-- Modal body -->
                <div
                    id="hb-mine-cam"
                    class="relative p-4 md:p-5 space-y-4 text-base leading-[2] text-gray-500 dark:text-gray-400">
                    <div id="hb-mine-zoom" class="hidden relative mb-6">
                        <label for="hb-mine-zoom-level" class="sr-only">
                            Zoom Level
                        </label>
                        <input
                            id="hb-mine-zoom-level"
                            type="range"
                            class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-500" />
                        <span
                            id="hb-mine-zoom-min"
                            class="text-sm text-gray-500 dark:text-gray-400 absolute start-0 top-6">
                        </span>
                        <span
                            class="text-sm text-gray-500 dark:text-gray-400 absolute start-1/3 -translate-x-1/2 rtl:translate-x-1/2 top-6"></span>
                        <span
                            id="hb-mine-zoom-mid"
                            class="text-sm text-gray-500 dark:text-gray-400 absolute start-1/2 -translate-x-1/2 rtl:translate-x-1/2 top-6">
                        </span>
                        <span
                            class="text-sm text-gray-500 dark:text-gray-400 absolute start-2/3 -translate-x-1/2 rtl:translate-x-1/2 top-6"></span>
                        <span
                            id="hb-mine-zoom-max"
                            class="text-sm text-gray-500 dark:text-gray-400 absolute end-0 top-6">
                        </span>
                    </div>
                    <video class="w-full h-full" playsinline></video>
                    <canvas class="hidden"></canvas>
                    <img
                        id="hb-mine-stamp"
                        src="${hb}"
                        class="animate-heartbeat w-44 h-44 opacity-0 -mt-6 transition-opacity duration-500 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
                    <aside
                        id="hb-mine-chest"
                        class="opacity-0 transition-opacity duration-500 p-2 text-center absolute w-72 -mt-7 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
                        <p
                            id="hb-mine-chest-title"
                            class="text-center bg-blue-100 text-blue-800 text-sm font-black rounded-sm dark:bg-blue-200 dark:text-blue-800"></p>
                        <p
                            class="mt-2 text-xs font-normal tracking-tight text-gray-900 dark:text-white">
                            <span>To:</span>
                            <span id="hb-mine-chest-to" class="font-bold">
                            </span>
                        </p>
                        <div id="hb-mine-timelock"></div>
                        <img id="hb-mine-chest-avatar" class="m-auto w-24" />
                        <span
                            id="hb-mine-chest-type"
                            class="absolute right-3 top-1/2 -translate-y-1/2 text-2xl font-bold tracking-tight text-gray-700 dark:text-gray-300">
                        </span>
                        <span
                            id="hb-mine-chest-diamonds"
                            class="absolute left-3 top-1/2 -translate-y-1/2 text-2xl font-bold tracking-tight text-gray-700 dark:text-gray-300">
                        </span>
                        <p
                            class="text-xs font-normal tracking-tight text-gray-900 dark:text-white">
                            <span>From:</span>
                            <span id="hb-mine-chest-from" class="font-bold">
                            </span>
                        </p>
                        <p
                            id="hb-mine-chest-time"
                            class="text-xs italic font-normal tracking-tight text-gray-900 dark:text-white"></p>
                        <p
                            class="mt-2 bg-blue-100 text-blue-800 text-sm font-semibold rounded-sm dark:bg-blue-200 dark:text-blue-800">
                            <span id="hb-mine-chest-karat" class="font-black">
                                0
                            </span>
                            <span>Karat Silver</span>
                        </p>
                    </aside>
                    <p id="hb-mine-message" class="text-sm font-medium mt-5">
                        Now mining for HeartBank® Chest or Stamp...
                    </p>
                </div>
                <!-- Modal footer -->
                <div
                    id="hb-mine-footer"
                    class="hidden flex-col items-center justify-around p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                    <div class="flex items-center justify-around">
                        <button
                            id="hb-mine-reset"
                            type="button"
                            class="text-white w-36 bg-teal-700 hover:bg-teal-800 focus:ring-4 focus:outline-none focus:ring-teal-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-teal-600 dark:hover:bg-teal-700 dark:focus:ring-teal-800">
                            Restart Mining
                        </button>
                        <button
                            id="hb-mine-switch"
                            type="button"
                            class="text-white w-36 bg-teal-700 hover:bg-teal-800 focus:ring-4 focus:outline-none focus:ring-teal-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-teal-600 dark:hover:bg-teal-700 dark:focus:ring-teal-800">
                            Front Camera
                        </button>
                    </div>
                    <div class="flex items-center justify-around mt-3">
                        <button
                            id="hb-mine-paste"
                            type="button"
                            class="text-white w-36 bg-teal-700 hover:bg-teal-800 focus:ring-4 focus:outline-none focus:ring-teal-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-teal-600 dark:hover:bg-teal-700 dark:focus:ring-teal-800">
                            Paste B-Chest
                        </button>
                        <button
                            id="hb-mine-import"
                            type="button"
                            class="text-white w-36 bg-teal-700 hover:bg-teal-800 focus:ring-4 focus:outline-none focus:ring-teal-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-teal-600 dark:hover:bg-teal-700 dark:focus:ring-teal-800">
                            Import B-Chest
                        </button>
                    </div>
                </div>
                <p
                    id="hb-mine-info"
                    class="hidden pb-3 mt-[-5px] text-xs text-center text-gray-600 dark:text-gray-400">
                    You can paste and import <strong>QR Code</strong> or
                    <strong>3B Crystal</strong>
                </p>
            </div>
        </div>
    </div>
`;
